// extracted by mini-css-extract-plugin
export default {"nowrap":"OrderLedgerTable_nowrap__8J0T3"};